import React from 'react';
export function EnvironmentalToNewsletterDivider() {
  return <div className="relative w-full overflow-hidden" style={{
    backgroundColor: '#1a1a1a'
  }} data-id="element-83">
      

      <style data-id="element-84">{`
        @keyframes envToNewsletterWave {
          0%, 100% {
            transform: translateX(0) scaleY(1);
          }
          50% {
            transform: translateX(-20px) scaleY(1.03);
          }
        }
        
        @media (prefers-reduced-motion: reduce) {
          svg path {
            animation: none !important;
          }
        }
      `}</style>
    </div>;
}